import Button from '@mui/material/Button';
import Grid from '@mui/material/Unstable_Grid2';
import Popover from '@mui/material/Popover';
import React from 'react';
import Typography from '@mui/material/Typography';

interface ButtonWithConfirmationProps {
  label: string;
  message?: string;
  onConfirm: () => void;
}

function ButtonWithConfirmation(props: ButtonWithConfirmationProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <div>
      <Button variant="contained" color="primary" onClick={handleClick}>
        {props.label}
      </Button>
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
      >
        <Typography sx={(theme) => ({ padding: theme.spacing(2) })}>
          {props.message || 'Are you sure?'}
        </Typography>
        <Grid container>
          <Grid>
            <Button onClick={handleClose}>Cancel</Button>
          </Grid>
          <Grid>
            <Button onClick={props.onConfirm}>OK</Button>
          </Grid>
        </Grid>
      </Popover>
    </div>
  );
}

export default ButtonWithConfirmation;
